<script>
	export let iconImage;
	export let short;
	export let long;
	export let iconType = "vessel";

	import vesselIconImages from "../Icons/Vessels/VesselIconImages";
	import aircraftIconImages from "../Icons/Aircraft/AircraftIconImages";
</script>

<style type="text/scss">

@use "../Theme/_smui-theme-variables.scss" as vars;

.alert-key-item {

	display: grid;
	padding-top: 8px;
	padding-bottom: 5px;

	border: 1px solid rgba(0, 0, 0, 0.2);
	border-radius: vars.$borderRadius;
	margin-bottom: 3px;

	p {
		text-align: center;
		margin-top: 2px;
		margin-bottom: 2px;
		font-size: 12px;
		font-family: monospace;
	}

	img {
		margin: 0 auto 0 auto;
		height: 24px;
	}
}
</style>

<div class='alert-key-item'>
	{#if iconType === "vessel"}
		<img src={vesselIconImages[iconImage]} alt={short} title={long} />
	{:else if iconType === "aircraft"}
		<img src={aircraftIconImages[iconImage]} alt={short} title={long} />
	{/if}
	<p title={long}>{short}</p>
</div>
